import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Clickable from '../../UI/Clickable/Clickable';
import classes from './Navbar.module.css';
import googleAnalytics from '../../../utils/googleAnalytics';

const Navbar = ({ onShowSidebar }) => {
  const hub = useSelector((state) => state.hub.hub);
  if (!hub) return null;
  const { logo } = hub;
  return (
    <span className={classes.blur}>
      <div className={classes.navbar}>
        <Clickable onClick={onShowSidebar}>
          <img
            className={classes.hamburger}
            src="/images/hamburger.svg"
            alt="hamburger"
          />
        </Clickable>
        <div className={classes.logoContainer}>
          <Link to="/">
            <img className={classes.logo} src={logo[0].url} alt="navLogo" />
          </Link>
        </div>
        <a
          className={classes.title}
          href="https://digitaltools.wy.com"
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            googleAnalytics({
              event: 'outboundLink',
              link_url: 'https://digitaltools.wy.com/',
              link_title: 'Content Hub',
              section_title: 'Main',
            })
          }
        >
          <span className={classes.title}>CONTENT HUB</span>
        </a>
      </div>
    </span>
  );
};
Navbar.propTypes = {
  onShowSidebar: PropTypes.func.isRequired,
};

export default Navbar;
